<template lang="html">
  <div class="log-list-warpper">
    <div class="order-line" v-if="type == 2" @click="addLog">
      <div class="left">
        <div>订单号:&nbsp;&nbsp;{{ this.orderId }}</div>
        <div>雇主:&nbsp;&nbsp;{{ this.name }}</div>
      </div>
      <div class="right"></div>
    </div>
    <div class="log-list-content">
      <loadData
        viewName="sevLoglist"
        :fetchData="serviceLogList"
        :fetchMethod="getLogList"
        :controlPage="changePage"
        :page="pageIndex"
        :pageSize="pageSize"
        :firstFetch="firstFetch"
        :hasErr="hasErr"
        :otherParams="{ errText: '暂无月嫂记录的日志内容', errImg: errorImg }"
      />
    </div>
  </div>
</template>
<script>
import loadData from '@/components/loadMore'

export default {
  components: {
    loadData
  },
  data() {
    return {
      origin: this.$route.params.origin || 1, // 类别 1 雇主打开服务日志列表 2 月嫂打开服务日志列表
      type: this.$route.params.type || 1, // 是否可编辑 1 不可编辑 2 可编辑
      orderId: this.$route.params.orderId || '',
      name: this.$route.query.name || '',
      pageIndex: 1,
      pageSize: 10,
      firstFetch: true,
      hasErr: false,
      tab: 1,
      serviceLogList: [],
      errorImg:
        '//cmspic-10004025.image.myqcloud.com/c98bc390-d446-11e9-8bdf-3976ec5da829_size_300x300'
    }
  },
  async created() {
    this.$$title('服务日志')
    await this.getLogList()
  },
  mounted() {
    this.$$allowRefreshOrShare(true, false)
  },
  methods: {
    ensureLoginB() {
      const bid = this.$$cookie('bid')
      const token = this.$$cookie('token')
      const empId = this.$$cookie('empId')
      if (bid && token) {
        return {
          bid,
          token,
          empId
        }
      } else {
        location.href = `${location.host}/login?cmd=login`
      }
    },
    async getLogList() {
      let list
      if (this.origin === '2') {
        const { bid, token, empId } = this.ensureLoginB()
        const { pageIndex, pageSize } = this
        const qurery = {
          bid,
          token,
          yuerCode: empId,
          orderId: this.orderId,
          startPage: pageIndex,
          pageSize
        }
        list = await this.$store.dispatch('fetchServiceLogListB', qurery)
      } else {
        const { uid, skey } = await this.$$ensureLogin()
        const { pageIndex, pageSize } = this
        const qurery = {
          uid,
          skey,
          orderId: this.orderId,
          startPage: pageIndex,
          pageSize
        }
        list = await this.$store.dispatch('fetchServiceLogList', qurery)
      }
      this.serviceLogList.push(...(list || []))
      this.$$loading(false)
      this.firstFetch = false
    },
    changePage(pageIndex) {
      this.pageIndex = pageIndex
    },
    addLog() {
      location.href = `/v/service-log/edit/new?oid=${this.orderId}&name=${this.name}&cmd=share&sharetype=0&refresh=no`
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/css/mixin';
.log-list-warpper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .order-line {
    width: 100%;
    background-color: #ffffff;
    padding: rem(22px) rem(30px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      flex: 1;
      font-size: rem(28px);
      color: #121212;
      line-height: rem(42px);
    }
    .right {
      width: rem(200px);
      height: rem(80px);
      margin-top: rem(2px);
      background: url('//cmspic-10004025.image.myqcloud.com/b850baa0-d463-11e9-8bdf-3976ec5da829_size_300x120')
        no-repeat center;
      background-size: contain;
    }
  }
  .log-list-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: rem(100px);
  }
}
</style>
